import { atom } from 'jotai';

export const uiStateAtomReachedFooter = atom(false);
